import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Container } from './styles';
import { store } from '../../store';
import { showDialog, hiddenDialog } from '../../store/modules/dialog/actions';

export default function MessageDialog() {
  const { visible, title, body, handleClose, arrayButtons } = useSelector(state => {
    return state.dialog.config;
  });

  function hiddenMessage() {
    const { dispatch } = store;
    dispatch(hiddenDialog());
  }

  let footer = (
    <div>
      <Button
        label="Sim"
        icon="pi pi-check"
        onClick={() => {
          hiddenMessage();
          if (handleClose) {
            handleClose(1);
          }
        }}
        className="p-button-success"
      />
      <Button
        label="Não"
        icon="pi pi-times"
        onClick={() => {
          hiddenMessage();
          if (handleClose) {
            handleClose(2);
          }
        }}
        className="p-button-danger"
      />
    </div>
  );

  if (Array.isArray(arrayButtons) && arrayButtons.length > 0) {
    footer = (
      <div>
        {arrayButtons.map((e, i) => {
          return (
            <Button
              key={`btnMessageDlg${i}`}
              label={e.label}
              icon={e.icon}
              title={e.title}
              onClick={() => {
                hiddenMessage();
                if (handleClose) {
                  handleClose(i + 1);
                }
              }}
              className={e.className}
            />
          );
        })}
      </div>
    );
  }

  return (
    <Container>
      <Dialog
        closable={false}
        footer={footer}
        header={title || 'Confirmação'}
        visible={visible}
        style={{ minWidth: '350px', maxWidth: '450px', width: '95%' }}
        modal
        onHide={() => {
          hiddenMessage();
          if (handleClose) {
            handleClose(0);
          }
        }}
      >
        {body || ''}
      </Dialog>
    </Container>
  );
}

/**
 * @param  {String} title Titulo do diálog
 * @param  {String} header
 * @param  {Function} handleClose
 */
export function showMessage(title, header, handleClose) {
  const { dispatch } = store;
  dispatch(showDialog(title, header, handleClose));
}

/**
 * @param  {String} title Titulo do diálog
 * @param  {String} header
 * @param  {[{label: String,title: String, icon: String, className: String}]} arrayButtons
 * @param  {Function} handleClose
 */
export function showMessageCustom(title, header, arrayButtons, handleClose) {
  const { dispatch } = store;
  dispatch(showDialog(title, header, handleClose, arrayButtons));
}
